/**
 * Tests if browser has support for localStorage (inspired by Modernizr)
 * Why is this necessary?
 * - Some Browsers may not support localStorage
 * - Browsers may disable localStorage while browsing in private/incognito mode
 * - Chrome provides the ability to block Cookies and LocalStorage
 *
 * This file exports result of the test as a boolean.
 *
 * @example
 * import supportsLocalStorage from 'utils/supportsLocalStorage'
 *
 * if (supportsLocalStorage) {
 *   localStorage.setItem('bgcolor', 'red')
 * }
 */
export default (() => {
  // using a unique test key to avoid colliding with existing ones
  const uid = `__storage_test_${Math.random().toString(36)}__`;
  let result;
  try {
    window.localStorage.setItem(uid, uid);
    result = window.localStorage.getItem(uid) === uid;
    window.localStorage.removeItem(uid);
    return result;
  } catch (error) {
    return false;
  }
})();
